import React from 'react';
import classes from './Contact.css';
import ContactAddress from '../../Sections/ContactAddress/ContactAddress';
import ContactForm from '../../Sections/ContactForm/ContactForm';
import Container from '../../../hoc/Container/Container';
const contact = (props) => (
    <div className={classes.contactBg} >
    <Container>
       <section className={classes.contact}>
        <div className={classes.contactFormContainer}>
        <ContactAddress/>
        <ContactForm />
        </div>
        </section>
    </Container>
    </div>
);

export default contact;



// WEBPACK FOOTER //
// ./src/components/Pages/Contact/Contact.js